import {
    HubConnectionBuilder,
    HttpTransportType,
    HubConnection,
} from "@microsoft/signalr";
import Configuration from "../foundation/Configuration";
import Logger from "../foundation/Logger";
import AppState from "../foundation/AppState";

var connection: HubConnection = null;
const callbacks: Record<string, (data: any) => void> = {};
const failbacks: Record<string, (error: Error) => void> = {};

export async function InitializeStatusHub(): Promise<boolean> {
    const jwt = await AppState.instance.getSessionJWT();

    if (!jwt) {
        throw new Error("No authentication found");
    }

    if (!connection) {
        connection = new HubConnectionBuilder()
            .withUrl(`${Configuration.socketsPath}/hubs/status`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets,
                accessTokenFactory: () => {
                    return `Bearer ${jwt}`;
                },
            })
            .withAutomaticReconnect()
            .build();

        connection
            .start()
            .then(result => {
                Logger.verbose("Connected to status socket");

                connection.on("Broadcast", message => {
                    let parts = message.split(":");

                    switch (parts[0]) {
                        case "should_update":
                            let key = `${parts[1]}:${parts[2]}`;
                            if (callbacks[key])
                                callbacks[key](
                                    JSON.parse(
                                        message.replace(
                                            `should_update:${key}:`,
                                            "",
                                        ),
                                    ),
                                );
                            break;
                    }
                });

                connection.onclose(error => {
                    Object.entries(callbacks).forEach(entry => entry[1](error));
                });
            })
            .catch(e => Logger.error(e));

        return true;
    } else {
        return false;
    }
}

function connectionWait() {
    return new Promise(resolve => {
        let around = () => {
            if (!connection || connection.state !== "Connected")
                setTimeout(around, 100);
            else resolve(null);
        };
        around();
    });
}

export async function StartMonitor(
    type: string,
    context: number,
    rate: number,
    stepped: boolean,
    callback: (data: any) => void,
    failback?: (error: Error) => void,
) {
    await connectionWait();

    if (!callbacks[`${type}:${context}`]) {
        callbacks[`${type}:${context}`] = callback;
        failbacks[`${type}:${context}`] = failback;

        connection.invoke(
            "Message",
            JSON.stringify({
                operation: "Start",
                type: type,
                contextId: context,
                rate: rate,
                stepped: stepped,
                useFile: false,
            }),
        );
    }
}

export async function ImmediateMonitor(type: string, context: number) {
    await connectionWait();

    connection.invoke(
        "Message",
        JSON.stringify({
            operation: "Immediate",
            type: type,
            contextId: context,
        }),
    );
}

export async function StopMonitor(type: string, context: number) {
    await connectionWait();

    delete callbacks[`${type}:${context}`];

    connection.invoke(
        "Message",
        JSON.stringify({
            operation: "Stop",
            type: type,
            contextId: context,
        }),
    );
}
